import type { Offset } from '@octopus-do/octopus-project-core'
import eq from 'fast-deep-equal'
import { useState } from 'react'
import type { DraggableData, DraggableEvent } from 'react-draggable'

export const useDrag = (
  stopHandler: (offset: Offset, e: DraggableEvent, data: DraggableData) => void,
  offset: Offset
) => {
  const [isDragging, setIsDragging] = useState(false)
  const onDrag = () => {
    setIsDragging(true)
  }

  const onStop = (e: DraggableEvent, data: DraggableData) => {
    setIsDragging(false)

    const nextPosition = { x: data.x, y: data.y }
    if (eq(nextPosition, offset)) {
      return
    }
    e.stopPropagation()
    stopHandler(nextPosition, e, data)
  }

  return {
    isDragging,
    onDrag,
    onStop,
  }
}
